import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { users } from "../../utils/content";
import useTyped from "../../utils/hooks/useTypedOnScroll";

import Credibility from "./Credibility";
import GraphicAnimation from "./graphicAnimation";
import TrustedAnalytics from "./trustedAnalytics";
import Insights from "./Insights";
import "./certilytics.css";
import "./HomeApp.css";

function NewHome({ kc }) {
  const {
    tokenParsed: {
      realm_access: { roles },
    },
  } = kc;
  // let words = null;
  const [words] = useTyped(
    [
      '<h1 className="text-white text-xl lg:text-2xl xl:text-4xl block">AI-Driven Predictive Analytics <br> Built for Healthcare</h1>',
    ],
    {
      typeSpeed: 40,
    }
  );
  const [user, setUser] = useState({});

  useEffect(() => {
    roles.forEach(rol => {
      if (users[rol]) return setUser(users[rol]);
    });
  }, []);

  useEffect(() => {
    gtag("event", "page_view", {
      page_title: "Home",
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  }, []);

  return (
    <html lang="en-US">
      <head>
        <link type="text/css" media="all" rel="stylesheet" />
        <title>Home - Certilytics</title>
      </head>
      <body className="home page-template-default page page-id-640 clearfix">
        <section className="w-full bg-primary-blue-content min-w-full relative h-fit lg:h-[calc(100vh-10px)]">
          <video
            playsInline
            autoPlay
            muted
            loop
            id="HomeBackgroundVideo"
            className="object-cover w-full h-full absolute top-0 left-0 z-10"
          >
            <source
              src="https://cdn.cloud.certilytics.com/web/CERTILYTICS_HOME_Master062323_1.mp4"
              type="video/mp4"
            />
          </video>
          <div className="w-full h-full bg-primary-blue-content bg-opacity-70 py-14 opacity-100 z-20 relative flex flex-col justify-center px-6">
            <div className="flex flex-col items-center justify-center text-center">
              <span className="text-white" ref={words} />
              <h2 className="text-white text-lg mt-8 tracking-normal max-w-3xl font-normal px-4 lg:px-0">
                Discover the unrealized potential of your data by turning it
                into a powerful analytic <br />
                asset with our proprietary Deep Learning and Generative AI
                technology
              </h2>
              <div className=" w-60 h-px bg-primary mt-6"></div>
            </div>
            <div className="w-full flex flex-col items-center mt-12">
              <div className="w-10/12 2xl:w-8/12 flex flex-col">
                <p className=" text-xl 2xl:text-3xl font-bold text-white max-w-none text-center">
                  {user?.heroSectionSubText ||
                    "Helping healthcare leaders drive more efficient and affordable healthcare"}
                </p>
              </div>
            </div>
          </div>
        </section>
        <TrustedAnalytics user={user} />
        <GraphicAnimation />
        <Credibility />
        <Insights />
        <footer className="clearfix !mt-0" style={{ padding: "10px 0px 10px" }}>
          <div className="col">
            <span className="copyright">
              Copyright © {new Date().getFullYear()} Certilytics
            </span>
          </div>
        </footer>
      </body>
    </html>
  );
}

function mapStateToProps(state) {
  return {
    kc: state.keycloak,
  };
}
export default connect(mapStateToProps)(NewHome);
